export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=4032d2fae94903485260d723f0a618701da92f3609&name=addToFolderEventAction!'